import Api from '@common/plugins/Api';
import Toaster from '@common/plugins/Toaster';
import Language from '@common/store/Language';

const isAbort = (error: unknown) => error instanceof Error && error.name === 'AbortError';

class GaiaRepository {
  private pendingListings = new Set<AbortController>();

  public search(url: string, data: DataObjectInterface, type: string|null = null) {
    const requestType = type ?? 'POST';
    const controller = new AbortController();
    this.pendingListings.add(controller);

    return this.request(requestType, url, requestType === 'GET' ? null : data, null, controller.signal)
      .then((response: DataObjectInterface) => ({
        page: (response?.page as unknown as number) || 1,
        itemsPerPage: (response?.itemsPerPage as unknown as number) || 0,
        count: (response?.count as unknown as number) || 0,
        data: (response?.data as unknown as DataObjectInterface[]) || [],
      }))
      // The page that asked for this listing is gone: nobody should react to it.
      .catch((error: unknown) => (isAbort(error) ? new Promise<never>(() => {}) : Promise.reject(error)))
      .finally(() => this.pendingListings.delete(controller));
  }

  public abortListings() {
    this.pendingListings.forEach((controller) => controller.abort());
    this.pendingListings.clear();
  }

  public request(
    method: string,
    url: string,
    body: object|null = null,
    params: object|null = null,
    signal: AbortSignal|null = null,
  ) {
    return Api.request(method, `/api/${url}`, body, params, signal)
      .then(async (response: Response) => {
        let data = {} as GaiaApiInterface;
        try {
          data = await response.json() as GaiaApiInterface;
          // eslint-disable-next-line
        } catch (error: any) {
        }

        try {
          if (response.status >= 200 && response.status < 400) {
            return data;
          }
          if (data.message) {
            Toaster.error(Language.translate(data.message));
          }

          return Promise.reject(data.errors);
          // eslint-disable-next-line
        } catch (error: any) {
          return Promise.reject(error.errors);
        }
      });
  }
}

export default new GaiaRepository();
